var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-create-layout',[_c('pages-form',{attrs:{"title":_vm.title,"parent":_vm.parent,"parentRes":_vm.parentRes,"section":_vm.section,"chapter":_vm.chapter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }